import { ILLUSTRATIONS } from "../../data/site";
import { useLanguage } from "../../i18n/LanguageContext";
import { LanguageSwitcher } from "./LanguageSwitcher";

export const Footer = () => {
  const { t } = useLanguage();
  const exploreLinks = [
    { label: t.nav.work, href: "#portfolio" },
    { label: t.nav.services, href: "#services" },
    { label: t.nav.process, href: "#process" },
    { label: t.nav.pricing, href: "#pricing" },
    { label: t.nav.contact, href: "#contact" },
  ];

  return (
    <footer data-testid="site-footer" className="bg-charcoal text-cream pt-20 pb-10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-cream/15">
          <div className="md:col-span-8">
            <div className="flex items-center gap-3">
              <img src={ILLUSTRATIONS.mark} alt="" className="h-10 w-10 object-contain invert opacity-80" />
              <span className="font-display text-4xl">Bergamot Studio</span>
            </div>
            <p className="mt-6 max-w-md text-cream/50 leading-relaxed">{t.footer.tagline}</p>
            <div className="mt-8"><LanguageSwitcher tone="light" /></div>
          </div>
          <div className="md:col-span-4">
            <span className="micro text-cream/40">{t.footer.explore}</span>
            <ul className="mt-5 space-y-3">
              {exploreLinks.map((l) => (
                <li key={l.href}><a href={l.href} className="btn-underline text-cream/80 hover:text-gold transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-cream/40">
          <span>© {new Date().getFullYear()} Bergamot Studio 9. {t.footer.rights}</span>
          <a href="mailto:hello@bergamotstudio9.com" className="hover:text-cream transition-colors">hello@bergamotstudio9.com</a>
        </div>
      </div>
    </footer>
  );
};
